import axiosInstance from './axios'

export default axiosInstance
